import React from 'react';
import { NavBar } from '../../Components/NavBar';
import { CenteredContainer } from '../../Components/CenteredContainer';
import { LazyP5Sketch } from '../../Backgrounds/LazyP5Sketch';
import { noiseWaveSketch } from '../../Backgrounds/noiseWaveSketch';
import pages from './../../Services/pages';
import './Styles/Contact.css';

export class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.BG = LazyP5Sketch(noiseWaveSketch);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        {this.BG}
        <NavBar pages={pages} active="contact" />
        <CenteredContainer maxWidth="30em" className="Contact__Visible">
          <div className="Contact">
            <div className="Contact__Header">
              <div className="Contact__Avatar">
                <img alt="avatar" src="./../images/me.jpg" />
              </div>
              <ul>
                <li>
                  <span className="Contact__you">You</span> Can
                </li>
                <li style={{ marginLeft: '.8em' }}>
                  Find <span className="Contact__me">Me</span>
                </li>
                <li style={{ marginTop: '-.2em', marginLeft: '.25em' }}>on</li>
              </ul>
            </div>

            <div className="Contact__Social">
              <div className="Contact__Social__Links">
                <a href="https://github.com/dxviie">
                  <i className="fab fa-github-square fa-2x" />
                  <div className="Links__Text">GitHub</div>
                </a>
                <a href="https://www.linkedin.com/in/d16de/">
                  <i className="fab fa-linkedin fa-2x" />
                  <div className="Links__Text">LinkedIn</div>
                </a>
                {/* <a href="https://medium.com/@davidvandenbogaerde">
                  <i className="fab fa-medium fa-2x" alt="LinkedIn icon" />
                  <div className="Links__Text">Medium</div>
                </a> */}
              </div>
            </div>
          </div>
        </CenteredContainer>
      </div>
    );
  }
}
